import { mbSize, Media } from '@foxrenderfarm/common'
import styled from 'styled-components'

export const Wrapper = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
  ${Media.lessThan(Media.small)} {
    padding-bottom: 0;
  }
`

export const Container = styled.div`
  display: flex;
  width: 1200px;
  height: fit-content;
  ${Media.lessThan(Media.small)} {
    width: 100%;
    justify-content: center;
  }
`

export const ArtWrapper = styled.div`
  width: 900px;
  padding: 40px 20px;
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(670)};
    padding: ${mbSize(60)} 0;
  }
`

export const Title = styled.h1`
  font-size: 30px;
  font-weight: bold;
  color: #333333;
  padding: 40px 0;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(48)};
    padding: 0 0 ${mbSize(60)};
  }
`

export const InnerHTML = styled.div<{ $isQaArt?: boolean }>`
  color: #333333;
  font-size: 16px;
  div,
  li,
  span,
  p,
  strong {
    margin-bottom: 24px;
    font-size: 16px !important;
    line-height: 24px !important;
  }
  li {
    list-style: unset;
    list-style-position: inside;
  }
  li * {
    display: inline;
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: #333333;
    font-size: 20px;
    margin-bottom: 24px;
  }
  h1,
  h1 * {
    font-size: 30px !important;
  }
  h2,
  h2 * {
    font-size: 24px !important;
    margin-top: 44px;
  }
  h3,
  h3 * {
    font-size: 20px !important;
  }
  a {
    color: #f3512b;
    font-weight: bold;
  }
  a:hover {
    text-decoration: underline;
  }
  pre {
    overflow-x: auto;
  }
  table {
    margin: 1em 0;
    width: 100%;
    overflow: hidden;
    border: 0;
    border-spacing: 0px;
  }
  tr {
    border: 1px solid #f6f7fb;
    font-size: 16px;
  }
  td {
    word-wrap: break-word;
    max-width: 7em;
    border: 1px solid #d5d5d5;
    padding: 5px;
    font-size: 16px;
    &:nth-of-type(odd) {
      background-color: #f1f1f1;
    }
  }
  th {
    border: 1px solid #d5d5d5;
    background-color: #d5d5d5;
    color: #fff;
    padding: 1em;
    font-size: 16px;
  }
  th td {
    text-align: center;
  }
  img {
    display: block;
    cursor: zoom-in;
    max-width: ${({ $isQaArt }) => ($isQaArt ? '740px' : '820px')};
    height: auto;
    margin: 40px auto;
    border-radius: 10px;
  }
  iframe,
  video {
    display: block;
    margin: 40px auto;
    max-width: 100%;
    border-radius: 10px;
  }
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(28)};
    div,
    li,
    span,
    p,
    strong {
      margin-bottom: ${mbSize(40)};
      font-size: ${mbSize(28)} !important;
      line-height: ${mbSize(44)} !important;
    }
    h1,
    h2,
    h3,
    h4,
    h5 {
      font-size: ${mbSize(32)} !important;
      margin-bottom: ${mbSize(20)};
    }
    h1,
    h1 * {
      font-size: ${mbSize(48)} !important;
    }
    h2,
    h2 * {
      font-size: ${mbSize(40)} !important;
      margin-top: ${mbSize(60)};
    }
    h3,
    h3 * {
      font-size: ${mbSize(32)} !important;
    }
    img {
      width: ${mbSize(620)};
      margin: ${mbSize(60)} auto;
    }
    td,
    th,
    tr {
      font-size: ${mbSize(28)};
    }
    iframe,
    video {
      max-width: 100%;
      margin: ${mbSize(60)} auto;
      height: auto;
    }
  }
`

export const QuickLinksWrapper = styled.div`
  margin-bottom: 40px;
`

export const QuickLinksTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 16px;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(40)};
    margin-bottom: ${mbSize(40)};
  }
`

export const QuickLink = styled.div<{ $tag: string }>`
  width: fit-content;
  display: flex;
  align-items: center;
  font-size: ${({ $tag }) => ($tag === '2' ? '20px' : '16px')};
  font-weight: ${({ $tag }) => ($tag === '2' ? 500 : 400)};
  color: #f3512b;
  cursor: pointer;
  &:not(:last-child) {
    margin-bottom: 16px;
  }
  svg {
    margin-left: 8px;
  }
  ${Media.lessThan(Media.small)} {
    font-size: ${({ $tag }) => ($tag === '2' ? mbSize(32) : mbSize(28))};
    margin-bottom: ${mbSize(40)};
    &:not(:last-child) {
      margin-bottom: ${mbSize(40)};
    }
    svg {
      width: ${mbSize(24)};
      height: ${mbSize(24)};
    }
  }
`
